<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="name"
    item-value="id"
    :items="staffs"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    clearable
    :loading="loading"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { Staff } from '@/plugins/api'

export default {
  data: () => ({ loading: false, staffs: [] }),
  props: { filters: Object, defaultStaffs: Array, options: Object },
  computed: { ...mapGetters({ roleIdByType: 'role/roleIdByType' }) },
  async created() {
    if (Array.isArray(this.defaultStaffs) && this.defaultStaffs.length) this.staffs = this.defaultStaffs
    await this.fetchAllStaffs()
  },
  methods: {
    async fetchAllStaffs(query) {
      this.loading = true
      try {
        const baseParams = { role: this.roleIdByType('monitor'), _sort: 'name:ASC', _limit: -1 }
        const params = { ...this.filters, ...query, ...baseParams }
        this.staffs = await Staff.fetch(params)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filters(newVale) {
      if (newVale) this.fetchAllStaffs(newVale)
    },
  },
}
</script>
